import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'

// Configuración de i18n
export default createI18n({
  legacy: false, // Usar la API de Composition
  globalInjection: true, // Inyectar $t y $tc en todos los componentes
  locale: 'es', // Idioma por defecto
  fallbackLocale: 'es', // Idioma de respaldo
  messages: {
    es, // Español cargado por defecto
    en  // Inglés también cargado para evitar errores al cambiar idioma
  }
}) 